"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESenderType = exports.ESendTwoFactorCodeStatus = void 0;
let ESenderType = exports.ESenderType = /*#__PURE__*/function (ESenderType) {
  /** SMS **/
  ESenderType["Sms"] = "sms";
  /** Звонок **/
  ESenderType["Call"] = "call";
  /** E-Mail **/
  ESenderType["Email"] = "email";
  return ESenderType;
}({});
let ESendTwoFactorCodeStatus = exports.ESendTwoFactorCodeStatus = /*#__PURE__*/function (ESendTwoFactorCodeStatus) {
  ESendTwoFactorCodeStatus["Succeed"] = "succeed";
  ESendTwoFactorCodeStatus["Failed"] = "failed";
  return ESendTwoFactorCodeStatus;
}({});